import {JsonObject} from 'type-fest';
import {asJsonObjectOrNull} from './asJsonObjectOrNull';

export function asJsonObject(o?: unknown): JsonObject {
    return asJsonObjectOrNull(o) ?? {};
}
